import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Select, Switch, Divider, message } from 'antd';
import axios from 'axios';

const { Option } = Select;

const InvoiceSettings = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [paperSizes, setPaperSizes] = useState([]);

    const fetchPaperSizes = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get('/api/settings/paper-sizes', { headers: { Authorization: `Bearer ${token}` } });
            setPaperSizes(res.data);
        } catch (error) {
            console.error('Failed to load paper sizes');
        }
    };

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get('/api/settings/invoice', { headers: { Authorization: `Bearer ${token}` } });
            form.setFieldsValue(res.data);
        } catch (error) {
            message.error('Failed to load settings');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPaperSizes();
        fetchSettings();
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.put('/api/settings/invoice', values, { headers: { Authorization: `Bearer ${token}` } });
            message.success('Settings saved');
        } catch (error) {
            message.error('Failed to save settings');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card title="Invoice Printing Configuration" bordered={false} style={{ background: 'transparent' }}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item name="paper_size" label="Paper Size" initialValue="80mm">
                    <Select>
                        {paperSizes.map(size => (
                            <Option key={size.value} value={size.value}>{size.label}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="show_logo" label="Show Logo" valuePropName="checked">
                    <Switch />
                </Form.Item>
                <Divider>Header & Footer</Divider>
                <div style={{ display: 'flex', gap: 16 }}>
                    <Form.Item name="header_en" label="Header (English)" style={{ flex: 1 }}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="header_ar" label="Header (Arabic)" style={{ flex: 1 }}>
                        <Input style={{ direction: 'rtl' }} />
                    </Form.Item>
                </div>
                <div style={{ display: 'flex', gap: 16 }}>
                    <Form.Item name="footer_en" label="Footer (English)" style={{ flex: 1 }}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="footer_ar" label="Footer (Arabic)" style={{ flex: 1 }}>
                        <Input style={{ direction: 'rtl' }} />
                    </Form.Item>
                </div>
                <Button type="primary" htmlType="submit" loading={loading}>Save Configuration</Button>
            </Form>
        </Card>
    );
};

export default InvoiceSettings;
